import { toast } from 'sonner';

/**
 * Détecte une session admin expirée (401) sur une réponse fetch. Si expirée, affiche un
 * message clair et recharge la page pour forcer un retour à l'écran de connexion (le
 * rechargement déclenche le contrôle d'authentification initial d'AdminPage).
 * Retourne true si la session était expirée (l'appelant doit arrêter son traitement).
 */
export const isSessionExpired = (res) => {
  if (res.status !== 401) return false;
  toast.error('Session expirée — reconnexion en cours...', { duration: 4000 });
  setTimeout(() => window.location.reload(), 1500);
  return true;
};
